<template>
  <div class="content">
    <div class="p1">
      <div class="p1-center">
        <div class="p1-title">
          <img src="@/img/web/logo.png" alt />

          <div class="title-tab">
            <div>
              <span @click="goAnchor('p1')">HOME</span>
              <span @click="goAnchor('p2')">ABOUT</span>
              <span @click="goAnchor('p3')">GALLERY</span>
              <span @click="goAnchor('p4')">CONTACT</span>
            </div>
            <img src="@/img/H5/Menu-Button.png" alt />
          </div>
        </div>
        <div class="p1-content">
          <div></div>
        </div>
        <div class="p1-down">
          <div @click="goAnchor('p2')"></div>
        </div>
      </div>
    </div>
    <div class="p1-flex"></div>
    <div class="p2">
      <div>
        <div class="p2-title">
          <p>{{ twoData.titleData.title }}</p>
          <div>
            <span
              v-for="(item, index) in twoData.titleData.textList"
              :key="index + 'title'"
              >{{ item }}</span
            >
          </div>
        </div>

        <div class="p2-center">
          <div v-for="(item, index) in twoData.spanList" :key="index + 'span'">
            <img :src="item.src" alt />
            <p>{{ item.title }}</p>
            <div>
              <span
                v-for="(item1, index1) in item.textList"
                :key="index + '-' + index1"
                >{{ item1 }}</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="p3">
      <div class="p3-title">
        <div>
          <span>OUR PORTFOLIO</span>
          <p>我们的作品</p>
          <div>
            <p style="width:800px !important">
              上海文广演艺（集团）、上海话剧艺术中心、上海京剧院、上汽·上海文化广场、上海广播电视台
              、1862时尚艺术中心、台湾百庭文化、上海开心麻花文化传媒、欧西爱司物流（上海）、上海滑稽剧团、北京大道文化、上海锦辉艺术传播、国际舞蹈中心、上海市剧本创作中心、浙江话剧团、上海开心麻花文化传媒、欧西爱司物流（上海）、上海滑稽剧团、北京大道文化、上海锦辉艺术传播、国际舞蹈中心、上海市剧本创作中心、浙江话剧团
            </p>
            <p></p>
          </div>
        </div>
        <div style="margin-bottom: 25px">
          <span ref="ALL" @click="changeClass('ALL')">ALL</span>
          <span ref="BRANDING" @click="changeClass('BRANDING')">BRANDING</span>
          <span ref="WEB" @click="changeClass('WEB')">WEB DESIGN</span>
        </div>
      </div>
      <div class="p3-content1" ref="img-list">
        <div>
          <Swiper ref="mySwiper" :options="swiperOptions">
            <SwiperSlide
              v-for="(item, index) in imgData"
              :key="index + 'image'"
            >
              <img
                @click="clickPageAndShowPagse(item, index)"
                :src="item"
                alt
              />
            </SwiperSlide>
            <div class="swiper-pagination" slot="pagination"></div>
          </Swiper>
        </div>
      </div>
    </div>
    <div class="p4">
      <div class="p4-title">
        <div>
          <span>OUR Address</span>
          <p><span>秀艺轩</span>在这里</p>
          <div>
            <p>上海市静安区彭江路602号大宁德比易园i座社群中心3楼303室</p>
            <p>
              Room 303, floor 3, building I, No. 602, Pengjiang Road, Jing'an
              District, Shanghai
            </p>
          </div>
        </div>
        <div>
          <img src="@/img/web/path.png" alt />
        </div>
      </div>
      <div class="p4-content">
        <baidu-map
          class="map"
          :center="center"
          :zoom="zoom"
          :dragging="true"
          :scroll-wheel-zoom="false"
          @ready="handler"
        >
          <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
          <bm-marker
            :position="{ lng: center.lng, lat: center.lat }"
            :dragging="true"
            animation="BMAP_ANIMATION_BOUNCE"
          ></bm-marker>
        </baidu-map>
      </div>
      <div class="p4-footer">
        <span>SHOWART</span> © <span>{{ new Date().getFullYear() }}</span> All
        Right Reserved. <a target="_blank" href="http://beian.miit.gov.cn/">沪ICP备20010017号-1</a>
      </div>
    </div>
    <div class="fled" @click="goAnchor('p1')"></div>
    <Dialog :src="image" :isOpen="openDialog" @closePage="closePage"></Dialog>
  </div>
</template>

<script>
import Dialog from "./dialog";
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import {
  title1,
  title2,
  title3,
  move01,
  move02,
  move03,
  move04,
  move05,
  move06,
  move07,
  move08,
  move09,
  move10,
  move11,
  move12,
  move13,
  move14,
  move15,
  move16,
  move17,
  move18,
  move19,
  move20,
  move21,
  move22,
  move23,
  move24,
  move25,
  move26,
  move27,
  move28
} from "@/utils/utils";
export default {
  components: {
    Dialog,
    Swiper,
    SwiperSlide
  },
  directives: {
    swiper: directive
  },
  name: "pc",
  data() {
    return {
      swiperOptions: {
        clickable: true,
        dynamicBullets: true,
        loop:true,
        autoplay: true,
        effect:"coverflow",
        slidesPerView: 5,
        pagination: {
          el: ".swiper-pagination"
        },
        centeredSlides: true,
        coverflowEffect: {
          rotate: 30,
          stretch: 10,
          depth: 60,
          modifier: 2,
          slideShadows: true
        }
      },
      image: null,
      baidumapSwitch: false,
      center: { lng: 0, lat: 0 },
      zoom: 16,
      // location: "深圳市",
      // keyword: "请输入搜索关键词",
      labelStyle: {
        padding: "15px",
        border: "1px solid #ccc",
        borderRadius: "5px",
        fontSize: "12px"
      },
      currentImg: 0,
      imgData: [
        move01,
        move02,
        move03,
        move04,
        move05,
        move06,
        move07,
        move08,
        move09,
        move10,
        move11,
        move12,
        move13,
        move14,
        move15,
        move16,
        move17,
        move18,
        move19,
        move20,
        move21,
        move22,
        move23,
        move24,
        move25,
        move26,
        move27,
        move28
      ],
      openDialog: false,
      twoData: {
        titleData: {
          title: "我们是谁?",
          textList: [
            "我们是一个多元化的文化传播公司",
            "我们是一支征战在策划、设计、演艺市场，具有复合型知识的创意团队",
            "我们是一群凝聚力强、务实高效的年轻人"
          ]
        },
        spanList: [
          {
            src: title1,
            title: "理念",
            textList: [
              "我们坚持以客户为中心，",
              "全方位运作各类商业文化活动，",
              "提供从创意设计到印刷制作、从策划到实施的全程服务。"
            ]
          },
          {
            src: title2,
            title: "创意",
            textList: [
              "我们拥有资深的广告设计专业人员、",
              "优秀的演艺服务体系、丰富的广告策划经验、",
              "独特创新的广告创意制作"
            ]
          },
          {
            src: title3,
            title: "服务",
            textList: [
              "我们珍视每一次合作机会，",
              "期待给客户更有创意，更高效益的媒介宣传效果，",
              "使您的活动和品牌以最经济有效的方式成为众人瞩目的焦点。"
            ]
          }
        ]
      }
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    }
  },
  // mounted() {
  //   this.clickPage(0);
  // },
  methods: {
    clickPageAndShowPagse(img, index) {
      this.image = index;
      this.openDialog = true;
      // this.clickPage(index);
    },
    closePage() {
      this.openDialog = false;
    },
    handler() {
      this.center.lng = "121.454205";
      this.center.lat = "31.292364";
    },
    goAnchor(selector) {
      const tag = document.getElementsByClassName(selector)[0].offsetTop;
      document.querySelector("html").scrollTop = tag;
    },
    // clickPage(index) {
    //   this.swiper.slideTo(3, 1000, false);
    //   if (index > 27) {
    //     this.currentImg = 0;
    //   } else if (index < 0) {
    //     this.currentImg = 27;
    //   } else {
    //     this.currentImg = index;
    //   }
    //
    //   this.imgData.forEach((i, index1) => {
    //     if (this.currentImg === index1) {
    //       this.$refs[`img-list`].scrollLeft = index1 * 470;
    //       this.$refs[`page-all`].scrollLeft = index1 * 24.63;
    //       this.$refs[`img${index1}`][0].className = "click-page-img";
    //       this.$refs[`page${index1}`][0].className = "click-page";
    //     } else {
    //       this.$refs[`img${index1}`][0].className = "";
    //       this.$refs[`page${index1}`][0].className = "";
    //     }
    //   });
    // },
    changeClass(type) {
      if (type === "ALL") {
        this.$refs[type].className = "click-tag";
        this.$refs["BRANDING"].className = "";
        this.$refs["WEB"].className = "";
      }
      if (type === "BRANDING") {
        this.$refs[type].className = "click-tag";
        this.$refs["ALL"].className = "";
        this.$refs["WEB"].className = "";
      }
      if (type === "WEB") {
        this.$refs[type].className = "click-tag";
        this.$refs["BRANDING"].className = "";
        this.$refs["ALL"].className = "";
      }
    }
  }
};
</script>

<style scoped lang="less">
.content {
  max-width: 1550px;
  min-width: 1200px;
  width: 100%;
  height: auto;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  position: relative;

  .fled {
    background: url("../img/H5/top.png") center 100% no-repeat;
    width: 80px;
    height: 80px;
    position: fixed;
    bottom: 50px;
    right: 50px;
  }
  > div {
    width: 100%;
    overflow: hidden;
  }
  > .p1 {
    height: auto;
    display: flex;
    justify-content: center;
    background-image: url("../img/H5/p1-bg.png");
    background-size: 100%;

    > .p1-center {
      padding: 80px 0 0 0;
      width: 90%;
      min-height: 1300px;

      > .p1-title {
        width: 100%;
        display: flex;
        justify-content: space-between;

        > img {
          width: 50px;
          height: 50px;
        }

        > .title-tab {
          font-family: "Microsoft YaHei","微软雅黑","MicrosoftJhengHei","华文细黑","STHeiti","MingLiu";
          display: flex;
          justify-content: flex-start;

          > img {
            width: 30px;
            height: 30px;
            &:hover {
              cursor: pointer;
            }
          }
          > div {
            display: flex;
            justify-content: space-between;
            width: 300px;
            margin-right: 30px;
            height: 100%;
            font-weight: 900;
            user-select: none;
            color: rgb(255, 255, 255);
            line-height: 1;
            text-align: left;

            > span {
              &:hover {
                cursor: pointer;
              }
            }
          }
        }
      }

      > .p1-content {
        width: 100%;
        padding: 200px 0 170px;
        display: flex;
        justify-content: center;
        align-items: center;

        > div {
          width: 465px;
          height: 285px;
          background-image: url("../img/H5/p1-center.png");
          background-size: 100% 100%;
        }
      }

      > .p1-down {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;

        > div {
          width: 57px;
          height: 57px;
          background-image: url("../img/H5/donw-button.png");
          background-size: 100% 100%;

          &:hover {
            cursor: pointer;
          }
        }
      }
    }
  }

  @media screen and (max-width: 1980px) {
    /* CSS 代码 */
    > .p1-flex {
      position: absolute;
      top: 1200px;
      width: 100%;
      height: 40vw;
      background-image: url("../img/web/p1dm.png");
      background-size: 100% 100%;
    }
  }

  @media screen and (min-width: 1980px) {
    /* CSS 代码 */
    > .p1-flex {
      position: absolute;
      top: 1000px;
      width: 100%;
      height: 40vw;
      background-image: url("../img/web/p1dm.png");
      background-size: 100% 100%;
    }
  }
  > .p2 {
    background: #29292c;
    display: flex;
    justify-content: center;
    > div {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      flex-direction: column;
      height: 1200px;
      width: 1200px;

      > .p2-title {
        width: 100%;
        text-align: center;
        flex-direction: column;
        justify-content: center;
        display: flex;

        > p {
          color: rgb(255, 255, 255);
          font-size: 27.395px;
          text-align: center;
        }

        > div {
          line-height: 2;
          color: rgb(255, 255, 255);
          font-size: 15px;
          text-align: center;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
        }
      }

      > .p2-center {
        width: 100%;
        padding: 100px 0;
        display: flex;
        justify-content: space-between;
        align-items: center;

        > div {
          margin-right: 40px;
          display: flex;
          justify-content: flex-start;
          flex-direction: column;
          align-items: center;
          > img {
            width: 100px;
            height: 100px;
          }
          > p {
            text-align: center;
            font-size: 19px;
            line-height: 1.262;
            color: rgb(242, 69, 56);
          }
          > div {
            text-align: center;
            line-height: 2.556;
            font-size: 12px;
            color: rgb(255, 255, 255);
            display: flex;
            justify-content: flex-start;
            align-items: center;
            flex-direction: column;
          }
        }
      }
    }
  }

  > .p3 {
    width: 100%;
    padding: 50px 0 0 0;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    background: #1d1d1d;

    > .p3-title {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      width: 1200px;
      min-width: 1000px;

      > :nth-child(2n-1) {
        > span {
          font-size: 14px;
          line-height: 1.2;
          text-align: left;
          color: rgb(242, 69, 56);
        }
        > p {
          font-size: 45px;
          color: rgb(255, 255, 255);
          line-height: 1.2;
          text-align: left;
        }

        > div {
          font-size: 17px;
          color: rgb(179, 179, 179);
          line-height: 1.6;
          text-align: left;
        }
      }

      > :nth-child(2n) {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        white-space:nowrap;
        &:hover {
          cursor: pointer;
        }

        > .click-tag {
          position: relative;
          margin-right: 20px;
          font-size: 14px;
          line-height: 1.2;
          text-align: left;
          color: #fff;

          &:after {
            position: absolute;
            bottom: -5px;
            height: 2px;
            left: 0px;
            width: 100%;
            content: "";
            background-color: #bb9b1d;
          }
        }
        > span {
          position: relative;
          margin-right: 20px;
          font-size: 14px;
          color: #666;
          line-height: 1.2;
          text-align: left;

          &:hover {
            &:after {
              position: absolute;
              bottom: -5px;
              height: 2px;
              left: 0px;
              width: 100%;
              content: "";
              background-color: #bb9b1d;
            }
            cursor: pointer;
            color: #fff;
          }
        }
      }
    }
    > .p3-content1 {
      margin: 50px 0;
      width: 100%;
      overflow: auto;
      height: auto;

      /*  > div {*/
      /*    width: 100%;*/
      /*    display: flex;*/
      /*    !*justify-content: space-between;*!*/
      /*    !*align-items: flex-end;*!*/
      /*    !*overflow-x: auto;*!*/

      /*    > .click-page-img {*/
      /*      height: 500px;*/
      /*      width: 450px;*/
      /*    }*/
      img {
        height: 450px;
        margin-right: 20px;
        width: 307px;
      }
      /*  }*/
      /*  &::-webkit-scrollbar {*/
      /*    !*滚动条整体样式*!*/
      /*    width: 10px; !*高宽分别对应横竖滚动条的尺寸*!*/
      /*    height: 5px;*/
      /*  }*/
      /*  &::-webkit-scrollbar-thumb {*/
      /*    !*滚动条里面小方块*!*/
      /*    border-radius: 10px;*/
      /*    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);*/
      /*    background: #535353;*/
      /*  }*/
      /*  &::-webkit-scrollbar-track {*/
      /*    !*滚动条里面轨道*!*/
      /*    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);*/
      /*    border-radius: 10px;*/
      /*    background: #ededed;*/
      /*  }*/
      /*}*/
      /*> .p3-footer {*/
      /*  color: #666;*/
      /*  display: flex;*/
      /*  width: 1000px;*/
      /*  justify-content: space-between;*/
      /*  align-items: center;*/

      /*  > div {*/
      /*    flex: 1;*/
      /*    margin: 0 20px;*/
      /*    overflow-x: auto;*/
      /*    &::-webkit-scrollbar {*/
      /*      !*滚动条整体样式*!*/
      /*      width: 10px; !*高宽分别对应横竖滚动条的尺寸*!*/
      /*      height: 2px;*/
      /*    }*/
      /*    &::-webkit-scrollbar-thumb {*/
      /*      !*滚动条里面小方块*!*/
      /*      border-radius: 10px;*/
      /*      box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);*/
      /*      background: #535353;*/
      /*    }*/
      /*    &::-webkit-scrollbar-track {*/
      /*      !*滚动条里面轨道*!*/
      /*      box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);*/
      /*      border-radius: 10px;*/
      /*      background: #ededed;*/
      /*    }*/
      /*    > .click-page {*/
      /*      color: #fff;*/
      /*    }*/
      /*    > span {*/
      /*      float: left;*/
      /*      text-align: center;*/
      /*      margin-right: 20px;*/
      /*      &:hover {*/
      /*        color: #fff;*/
      /*        cursor: pointer;*/
      /*      }*/
      /*    }*/
      /*    display: flex;*/
      /*  }*/
      /*  > .prev {*/
      /*    &:hover {*/
      /*      cursor: pointer;*/
      /*      color: #fff;*/
      /*    }*/
      /*    &:before {*/
      /*      content: " -- ";*/
      /*    }*/
      /*  }*/
      /*  > .next {*/
      /*    &:hover {*/
      /*      color: #fff;*/
      /*      cursor: pointer;*/
      /*    }*/
      /*    &:after {*/
      /*      content: " -- ";*/
      /*    }*/
      /*  }*/
    }
  }

  > .p4 {
    width: 100%;
    height: auto;
    padding: 200px 0 0 0;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    background: #1d1d1d;
    > .p4-title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 1200px;
      min-width: 1000px;

      > :nth-child(2n-1) {
        > span {
          font-size: 14px;
          line-height: 1.2;
          text-align: left;
          color: rgb(242, 69, 56);
        }
        > p {
          > span {
            color: rgb(242, 69, 56);
          }
          font-size: 45px;
          color: rgb(255, 255, 255);
          line-height: 1.2;
          text-align: left;
        }

        > div {
          font-size: 17px;
          color: rgb(179, 179, 179);
          line-height: 1.6;
          text-align: left;
        }
      }
    }
    > .p4-content {
      height: auto;
      width: 1200px;

      > .map {
        background: #fff;
        height: 300px;
        width: 100%;
      }
    }
    > .p4-footer {
      padding: 50px;
      color: #888;
      font-size: 16px;

      > span {
        color: rgb(242, 69, 56);
      }
      > a {
        color: rgb(255, 255, 255);
      }
    }
  }
}
</style>
